<template>
  <div class="title">{{ title }}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'title'
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding-left: 6px;
  border-left: 3px solid #3F86FF;
  line-height: 18px;
  font-size: 14px;
  margin: 15px 0;
  font-weight: bold;
}
</style>
